import { Navigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';

const PrivateRoutes = ({ children }) => {
	const { user } = UserAuth();
	if (!user) {
		return <Navigate to="/login" />;
	}
	return children;
};

export default PrivateRoutes;
